/**
 * Bottom navigation (Luka's APPNAV): Početna · Akustične · Vođene · Dnevnik · Omiljene · Pretplata · Profil.
 *
 * Akustične shows only when the build sets VITE_FEATURE_ACOUSTIC=true. Every tab is a flex-1, at
 * least 44 px tall target; labels are sized so that 7 tabs fit at 320 px (9 px below 375 px). Tabs
 * have no min-w-0, so a tab never shrinks below its label (at least 44 px, text plus 1 px on each
 * side): a long label (el "Ημερολόγιο") widens its own tab instead of running into its neighbours.
 * The bar is var(--bottom-nav-height) tall plus the bottom safe-area inset; FixedAudioPlayer and
 * MainLayout use the same expression.
 */
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '@/store';
import { getBottomNavTranslation } from '@/utils';
import { isAcousticEnabled } from '@/config/features';
import { getNavItems, isNavItemActive } from '@/config/navigation';

export function BottomNav() {
  const language = useLanguage();
  const { pathname } = useLocation();
  const items = getNavItems({ acoustic: isAcousticEnabled() });

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 h-[calc(var(--bottom-nav-height)+env(safe-area-inset-bottom))] border-t bg-card pb-[env(safe-area-inset-bottom)]">
      <div className="mx-auto flex h-full max-w-screen-md items-stretch">
        {items.map((item) => {
          const isActive = isNavItemActive(item, pathname);
          const Icon = item.icon;

          return (
            <Link
              key={item.id}
              to={item.path}
              aria-label={getBottomNavTranslation(item.ariaLabelKey, language)}
              aria-current={isActive ? 'page' : undefined}
              className={`flex min-h-11 flex-1 flex-col items-center justify-center gap-1 transition-colors ${
                isActive ? 'text-primary' : 'text-muted-foreground hover:text-primary'
              }`}
            >
              <Icon className="h-5 w-5 flex-shrink-0" aria-hidden="true" />
              <span className="min-w-11 whitespace-nowrap px-px text-center text-[9px] font-medium leading-none tracking-tighter xs:text-[10px] xs:tracking-tight">
                {getBottomNavTranslation(item.labelKey, language)}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
